import Logger from '../Log'
import StartEventHook from './StartEventHook'
import { bidderForCode } from '../utils'

const Log = Logger.for('NobidHook')

export default class NobidHook extends StartEventHook {
  constructor () {
    super('NobidHook')
  }

  async run (remoteConfig) {
    const v = remoteConfig.media().video
    const nobid = bidderForCode('nobid', remoteConfig.bidders(), false)
    if (!v || !nobid) {
      return
    }

    Log.debug('Injecting nobid video cfg')

    nobid.params.video = {
      skippable: 0,
      playback_method: ['auto_play_sound_off', 'mouseover'],
      position: ['atf', 'sidebar'],
      mimes: ['video/mp4'],
      minDuration: v.minDuration ? v.minDuration : 1,
      maxduration: v.maxduration ? v.maxduration : 30,
      frameworks: v.apis && v.apis.length ? v.apis : [1]
    }
  }
}
